import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useLayoutEffect, useMemo } from "react";
import "./LcaAndBwv.css";
import {
  setActiveTab,
  setCity,
  setMonth,
  setHideSkipped,
  setCurrentPage,
  fetchCities,
} from "../../../../redux/slices/LcaSlice";
import {
  fetchGotton24,
  setSelectedCustomer,
} from "../../../../redux/slices/ReportsSlice";
import {
  setIsChatModalOpen,
  setSampleAd,
} from "../../../../redux/slices/SearchBarSlice";
import {
  setMessages,
  setSelectedConversation,
} from "../../../../redux/slices/MsgSlice";
import ChatModal from "../../modals/ChatModal";
import BwvBox from "../BwvBox";
import LcaBox from "../LcaBox";
import { toast } from "react-toastify";
import LcaFilterLogic from "./LcaFilterLogic";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import LcaBoxSkeleton from "./LcaBoxSkeleton";
import LcaRecomandModal from "../LcaRecomandModal";
import Select from "react-select";
import CallDialog from "../AutoNeed/CallDialog";
import TabNav from "../../../../pages/DashboardPages/MessageTemplates/MediaTemplates/TabNav";
import PaginationFile from "../../../../pages/PaginationFile";
import { createCombinedListings, renderBizzListings } from "./BizzListCards";
import OnlineStatus from "../../../Layout/onlineStatus";
import NoDataImage from "../../../../assets/images/nodatafoundexplorer1.png";
import "../../../../pages/DashboardPages/NeedPages/searchResults.css";
import AutoNeedModal from "../AutoNeed/AutoNeedModal";
const SPECIAL_SUBCATEGORY_ID = 63;
const ADS_PER_PAGE = 10;

const LcaAndBwv = ({ scrollPopupVisible }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    activeTab,
    hideSkipped,
    recomandModal,
    selectedSubCategory,
    month,
    city,
    currentPage,
    needCities,
    citiesLoading,
  } = useSelector((state) => state.lcAds);
  const { sampleAd, isChatModalOpen } = useSelector((state) => state.searchBar);
  const { onlineView } = useSelector((state) => state.lcaAndVendors);
  const { gotton24Hr, gotton24HrLoading, gotton24HrError, selectedCustomer } =
    useSelector((state) => state.reports);
  const {
    loading,
    finalLcaAndBwv,
    totalRecords,
    bizz,
    loadingBizz,
    errorBizz,
  } = useSelector((state) => state.lcaAndVendors);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const cityOptions = needCities.map((city) => ({
    value: city,
    label: city,
  }));
  const customerOptions = gotton24Hr.map((user) => ({
    value: user,
    label:
      `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
      "Unnamed User",
  }));

  const effectiveActiveTab = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabFromUrl = searchParams.get("tab") || "Vendor";
    return tabFromUrl;
  }, [location.search]);

  useLayoutEffect(() => {
    if (effectiveActiveTab !== activeTab) {
      dispatch(setActiveTab(effectiveActiveTab));
      // dispatch(setSelectedCustomer(null));
    }
  }, [effectiveActiveTab, activeTab, dispatch]);
  console.log(month, "month");
  useEffect(() => {
    if (
      selectedSubCategory &&
      selectedSubCategory.id === SPECIAL_SUBCATEGORY_ID
    ) {
      dispatch(fetchGotton24());
      dispatch(fetchCities());
    }
  }, [selectedSubCategory]);

  const closeModal = () => {
    dispatch(setSelectedConversation(null));
    dispatch(setIsChatModalOpen(false));
    dispatch(setSampleAd(null));
    dispatch(setMessages(null));
  };

  const handleMonthChange = (newMonth) => {
    dispatch(setMonth(newMonth));
    dispatch(setCurrentPage(1));
  };
  const resetfilters = () => {
    dispatch(setCity(""));
    dispatch(setMonth(""));
    dispatch(setSelectedCustomer(null));
    dispatch(setHideSkipped(true));
    dispatch(setCurrentPage(1));
  };
  const navBar = () => {
    const isVendorActive = effectiveActiveTab === "Vendor";
    const isCustomerActive = effectiveActiveTab === "Customers";
    return (
      <div
        className="col-lg-6 d-flex row mt-3 view-tabs w-100"
        style={{ marginLeft: "2px" }}
      >
        <h5
          className={`col-sm-4 ${isVendorActive ? "active" : ""} mx-0`}
          onClick={() => {
            if (activeTab === "Vendor") return;
            dispatch(setActiveTab("Vendor"));
            const searchParams = new URLSearchParams(location.search);
            searchParams.set("tab", "Vendor");
            navigate(
              {
                pathname: location.pathname,
                search: searchParams.toString(),
              },
              { replace: true }
            );
            resetfilters();
          }}
          style={{
            textDecoration: isVendorActive ? "underline" : "none",
            cursor: "pointer",
            width: "50%",
          }}
        >
          View Vendors
        </h5>
        <h5
          className={`col-sm-4 ${isCustomerActive ? "active" : ""} mx-0`}
          onClick={() => {
            if (activeTab === "Customers") return;
            dispatch(setActiveTab("Customers"));
            const searchParams = new URLSearchParams(location.search);
            searchParams.set("tab", "Customers");
            navigate(
              {
                pathname: location.pathname,
                search: searchParams.toString(),
              },
              { replace: true }
            );
            resetfilters();
          }}
          style={{
            textDecoration: isCustomerActive ? "underline" : "none",
            cursor: "pointer",
            width: "50%",
          }}
        >
          View Customers
        </h5>
      </div>
    );
  };

  const combinedListings = createCombinedListings(finalLcaAndBwv);

  return (
    <>
      <LcaFilterLogic currentPage={currentPage} />
      {selectedSubCategory &&
        selectedSubCategory.id === SPECIAL_SUBCATEGORY_ID && (
          <>
            {navBar()}
            {effectiveActiveTab === "Customers" && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "1rem",
                  marginBottom: "0.5rem",
                }}
              >
                <div
                  style={{ flex: "1 1 calc(25% - 0.75rem)", minWidth: "150px" }}
                >
                  <FormGroup>
                    <Label for="city">City:</Label>
                    <Select
                      value={
                        cityOptions.find((opt) => opt.value === city) || null
                      }
                      onChange={(selected) =>
                        dispatch(setCity(selected?.value))
                      }
                      menuPortalTarget={document.body}
                      isDisabled={citiesLoading}
                      placeholder="Select City"
                      options={cityOptions}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                        menu: (provided) => ({
                          ...provided,
                          overflowY: "auto",
                        }),
                        control: (provided) => ({
                          ...provided,
                          minHeight: "40px",
                        }),
                      }}
                    />
                  </FormGroup>
                </div>
                <div
                  style={{ flex: "1 1 calc(25% - 0.75rem)", minWidth: "150px" }}
                >
                  <FormGroup>
                    <Label for="customers_24">Customer 24hrs:</Label>
                    <Select
                      id="customers_24"
                      value={
                        selectedCustomer
                          ? customerOptions.find(
                              (opt) => opt.value.id === selectedCustomer.id
                            )
                          : null
                      }
                      onChange={(selected) => {
                        const selectedValue = selected?.value || null;
                        dispatch(setSelectedCustomer(selectedValue));
                        if (selectedValue) {
                          navigate(`/userDetails/${selectedValue.customer_id}`);
                        }
                      }}
                      isDisabled={gotton24HrLoading}
                      placeholder="Select Name"
                      options={customerOptions}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }),
                        control: (provided) => ({
                          ...provided,
                          minHeight: "40px",
                        }),
                      }}
                      noOptionsMessage={() =>
                        gotton24HrError
                          ? "Error Loading Names"
                          : gotton24Hr.length === 0
                          ? "No Names Available"
                          : "No match found"
                      }
                    />
                  </FormGroup>
                </div>
                <div
                  style={{ flex: "1 1 calc(25% - 0.75rem)", minWidth: "150px" }}
                >
                  <FormGroup>
                    <Label for="month">Select Month & Year:</Label>
                    <Input
                      //make year also avaliable
                      id="month"
                      type="month"
                      name="month"
                      placeholder="Select Month & Year"
                      min="2000-01"
                      value={month}
                      // max={new Date().toISOString().slice(0, 7)}
                      onChange={(e) => handleMonthChange(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "#dc3545", // red for danger
                      color: "white",
                      padding: "  8px",
                      fontSize: "12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      userSelect: "none",
                      transition: "background-color 0.3s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#b02a37")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#dc3545")
                    }
                    onClick={() => resetfilters()}
                  >
                    Clear Filters
                  </span>

                  <span
                    style={{
                      backgroundColor: "#007bff", // blue for primary
                      color: "white",
                      padding: " 8px",
                      fontSize: "12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      userSelect: "none",
                      transition: "background-color 0.3s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#0056b3")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#007bff")
                    }
                    onClick={() => {
                      dispatch(setHideSkipped(!hideSkipped));
                      dispatch(setCurrentPage(1));
                    }}
                  >
                    {hideSkipped ? "Show All" : "Hide Skipped"}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      <div className="my-3">
        {loading ? (
          <div>
            {Array.from({ length: ADS_PER_PAGE }).map((_, index) => (
              <LcaBoxSkeleton key={index} />
            ))}
          </div>
        ) : !finalLcaAndBwv || finalLcaAndBwv.length === 0 ? (
          <div className="no-data-card">
            <div className="no-data-content">
              <img src={NoDataImage} alt="No data" className="no-data-icon" />
              <h3>No Data Available</h3>
              <p>
                It looks like there’s nothing to show here yet. Try searching
                other results or check back later.
              </p>
            </div>
          </div>
        ) : (
          <div>
            {combinedListings.map((item, index) => {
              if (item.type === "ad") {
                const ad = item.data;
                const fullName = `${ad.firstName || ""} ${
                  ad.lastName || ""
                }`.trim();
                return (
                  <span key={ad.Id} style={{ cursor: "pointer" }}>
                    <div
                      className="mb-1"
                      style={{
                        fontSize: "medium",
                        display: "inline-flex",
                        marginTop: "5px",
                        display: "flex",
                        flexDirection: "row",
                        gap: "15px",
                      }}
                      onClick={() => {
                        if (islogin) {
                          navigate(`/userDetails/${ad.createdBy}`);
                        } else {
                          toast.info("Please login to view profile");
                        }
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          if (islogin) {
                            navigate(`/userDetails/${ad.createdBy}`);
                          } else {
                            toast.info("Please login to view profile");
                          }
                        }
                      }}
                      aria-label={`View profile for ${fullName}`}
                    >
                      {fullName} ({ad?.customerUniqueId})
                      {onlineView && (
                        <span className="mt-2">
                          <OnlineStatus createdBy={ad?.createdBy} />
                        </span>
                      )}
                    </div>
                    {ad.postType === "need" ? (
                      <LcaBox ad={ad} />
                    ) : (
                      <BwvBox ad={ad} />
                    )}
                  </span>
                );
              } else if (item.type === "bizz") {
                return (
                  <div key={`bizz-${item.bizz_value}-${index}`}>
                    {renderBizzListings(bizz, item.bizz_value)}
                  </div>
                );
              }
              return null;
            })}
          </div>
        )}
      </div>
      <PaginationFile
        totalRecords={totalRecords}
        usersPerPage={ADS_PER_PAGE}
        currentRecordsPerPage={currentPage}
        setCurrentRecordsPerPage={(page) => dispatch(setCurrentPage(page))}
      />
      <ChatModal
        isOpen={isChatModalOpen}
        closeModal={closeModal}
        ad={sampleAd}
        homepage="true"
      />
      {recomandModal && <LcaRecomandModal />}
      <AutoNeedModal />
      <CallDialog />
    </>
  );
};

export default LcaAndBwv;
